var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDjLogoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 780.65 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ee2b46;}.cls-2{fill:#799ad0;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "dj-logo-horizontal-sign") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_15",
    "data-name": "Layer 15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M209.76,90.83h19.52l2.95,3v48l-3,3H209.76Zm16.49,48v-42H215.74v42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M322.52,90.83H342v6H328.49v17.72h10.37v6H328.49v18.37H342v6H322.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M432.32,141.88v-8.42h6v5.4h10.52V120.57l-13.54-.15-2.95-3V93.78l3-3h16.49l2.95,3v8.28h-6V96.8H438.29v17.65l13.54.14,2.95,3v24.27l-2.95,3H435.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M546.58,90.83h6v54h-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M644.64,141.88V93.78l3-3h16.49l3,3V104h-6V96.8H650.62v42.06h10.51V122.15h-5.25v-6h11.23v25.71l-3,3H647.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M764.09,111.13v33.7h-6v-54h6l10.59,34.27V90.83h6v54h-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M115.07,102.91c-8-3.8-13.87-5.74-35.36-12a399,399,0,0,0-43-10.37c-5-.8-9.35-1.81-9.35-1.81A42.16,42.16,0,0,0,13,70.29c-5.18-1.77-7.2-1.15-9.33.12s-6.23,4.79-1.26,5.9c4.5,1,14.17,3.75,16.9,6.87a204.13,204.13,0,0,0,20.59,20c6.82,5.58,30,21.47,30,21.47a166.06,166.06,0,0,0-4.67,17.25c-1.36,6.53-.18,11.79,11.26,6,15.8-8,30.53-18.28,40.67-29.52C125.72,108.79,122.37,106.37,115.07,102.91Zm-3.68,11c-2,2.62-8.68,10.18-19.94,18.35s-16,11.6-17.3,9.78-1.57-8.28-.81-11.05.33-4.12,1.32-4.29,4.57,3.62,8.54,4.89a10.64,10.64,0,0,0,4.74-1.49,7.51,7.51,0,0,0,2.47-3.46S82,123,78.25,118.26c-1.71-2.18,7-18.89,6.07-18-6.52,6.67-9.13,13-10.32,14.42-1.21-1.13-2.85-2.67-3.89-3.83C62.75,102.62,60.37,99.35,55.77,98s-7,3.39-7,3.39S42.76,94.94,38.25,91s-6.72-6.2-6.72-6.2c7,.83,19,4,39.24,9.77a305.29,305.29,0,0,1,38.65,13.53C113.92,110.11,112.88,111.91,111.39,113.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M152.15,115.11a202.78,202.78,0,0,0-20.56,6.14S113.61,68.72,108.1,50C102,29.14,99.5,20.19,99.83,20.74a29.54,29.54,0,0,0,7.25,8.64,18.27,18.27,0,0,0,11.23,3.44s-2.69-2.1-6.3-5.31c-4-3.52-11.31-15.12-13.63-19S94.67,1.43,93.2.42c-.78-.54-5.57-.49-6.84-.23-2.26.46-1.81,1.4-.48,5.34s20,62.62,27.12,83.33,11.79,34.37,11.79,34.37-18.68,6.11-25.07,9.15c-8.8,4.18-11.16,8.4-11.2,11.13s1.82,6.91,7.57,12.93c6.16,6.44,19.86,20.2,29.07,30,9,9.67,17.21,17.47,21.12,21.23s8.61,8.69,9.66,8.26,3.48-2.18,4.14-3.84,4.62-1.89-3.27-25c-7.39-21.62-23.26-60.37-23.26-60.37s18.78-7,25.43-9.28,9.24-2.4,17.93-5.35C186.12,109,163.25,112.63,152.15,115.11ZM145.21,180c7.44,20.36,4.67,18.71,3.59,17.81s-6.56-6-18.4-17.68c-11.34-11.23-30.53-30.85-31.75-34.24-1.06-2.94,1.76-6.11,11.77-10.62,12.58-5.67,15.91-6.58,15.91-6.58C137.08,157.66,137.76,159.68,145.21,180Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDjLogoSmall);
export default __webpack_public_path__ + "static/media/dj-logo-small.aec44b72a8df7d1d1fb048a995341e2e.svg";
export { ForwardRef as ReactComponent };